import { render, staticRenderFns } from "./reference-list.vue?vue&type=template&id=503a4ab9&scoped=true&"
import script from "./reference-list.vue?vue&type=script&lang=js&"
export * from "./reference-list.vue?vue&type=script&lang=js&"
import style0 from "./reference-list.vue?vue&type=style&index=0&id=503a4ab9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a4ab9",
  null
  
)

export default component.exports